import {NgModule} from '@angular/core';
import {GroupDetailComponent} from './components/groups/group-detail.component';
import { SharedModule } from '../../shared/shared.module';
import { PeopleService } from './services/people.service';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        GroupDetailComponent
    ],
    exports: [
        GroupDetailComponent,
        PeopleService
    ]
})
export class PeopleModule {
    constructor() { }
}